module.exports = __webpack_public_path__ + "477640e99f05937bb2a4187f3f83df85.pdf";